<template>
  <div class="notification-list__item"
       :class="{'notification-list__item--new': isNew}"
       v-observe-visibility="rowIsVisibleHandler">
    <padding row class="flex--middle">
      <div class="flex__column flex--100" @click="clickHandler">
        {{ content }}
      </div>
      <div v-if="isRemovable" class="flex__row notification-list__remove">
        <close-button size="small" @click="deleteHandler"/>
      </div>
    </padding>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { path } from 'ramda'
import Padding from '../Utils/Padding'
import CloseButton from '../Buttons/CloseButton.vue'

export default {
  name: 'NotificationListItem',
  components: { CloseButton, Padding },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNew() {
      return this.notification.attributes.new
    },
    isRemovable() {
      return this.notification.attributes.removable
    },
    content() {
      return this.notification.attributes.content
    },
    orderId() {
      return path(['attributes', 'data', 'orderId'], this.notification)
    },
    offerId() {
      return path(['attributes', 'data', 'offerId'], this.notification)
    },
  },
  methods: {
    ...mapActions(
      {
        xhrMarkAsViewed: 'notifications/xhrMarkAsViewed',
        xhrDeleteNotification: 'notifications/xhrDelete',
      },
    ),
    rowIsVisibleHandler(visible) {
      if (visible && this.isNew) {
        setTimeout(() => {
          this.xhrMarkAsViewed({ notification: this.notification })
        }, 2500)
      }
    },
    deleteHandler() {
      this.xhrDeleteNotification({ notification: this.notification })
    },
    clickHandler() {
      if (this.offerId && this.$route.params.offerId !== this.offerId) {
        this.$router.push({
          name: 'Offer',
          params: { offerId: this.offerId },
        })
      } else if (this.orderId && this.$route.params.orderId !== this.orderId) {
        this.$router.push({
          name: 'Order',
          params: { orderId: this.orderId },
        })
      }
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.notification-list__item:hover {
  background-color: #e0e0e0;
  cursor: pointer;
}
</style>
